module.exports = __webpack_public_path__ + "static/media/tickGreen.0ea2b629.svg";